import { buildElementId } from '../utils';

import {
  ValidateNumeric,
  ValidateRegExp,
  ValidateSegmented,
  ValidateSelector,
} from './ElementValidators';

const getValue = (answer) => {
  return (answer || { value: '' }).value;
};

const validateMake = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  let makeMessage =
    questions.make?.errorLabel ||
    (getMessage
      ? `${caption} : ${
          questions.make?.question ??
          getMessage('labelText.make')
        } - ${getMessage('error.fill.in.missing.information')}`
      : '');
  makeMessage = makeMessage.replace(
    '- undefined',
    (getMessage ?? questions.boatType.getMessage)(
      'error.fill.in.missing.information'
    )
  );
  // Make
  newErrors = ValidateRegExp({
    value: getValue(questions.make),
    id: buildElementId(id, 'BOAT_MAKE'),
    newErrors,
    validateAll,
    length: 1,
    questionID,
    regExp: '(^[0-9a-zA-Z\\u00C0-]+([ |-][0-9a-zA-Z\\u00C0-]+)*$)|(^$)',
    errorLabel:makeMessage,
  });
  return newErrors;
};

const validateModel = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  let modelMessage =
      questions.model?.errorLabel ||
      (getMessage
        ? `${caption} : ${
            questions.model?.question ??
            getMessage('labelText.model')
          } - ${getMessage('error.fill.in.missing.information')}`
        : '');
      modelMessage = modelMessage.replace(
      '- undefined',
      (getMessage ?? questions.boatType.getMessage)(
        'error.fill.in.missing.information'
      )
    );

    // Model
    newErrors = ValidateRegExp({
      value: getValue(questions.model),
      id: buildElementId(id, 'BOAT_MODEL'),
      newErrors,
      validateAll,
      length: 1,
      questionID,
      regExp:
        "(^[0-9a-zA-Z\\u00C0-\\u017F'´`]+([ |-][0-9a-zA-Z\\u00C0-\\u017F'´`]+)*$)|(^$)",
      errorLabel: modelMessage,
    });

  return newErrors;
};

const validateFrameMaterial = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  // Frame material
  newErrors = ValidateSelector(
    getValue(questions.framematerial),
    buildElementId(id, 'BOAT_FRAMEMATERIAL'),
    newErrors,
    validateAll,
    questionID,
    getMessage
      ? `${caption} : ${
          questions.framematerial?.question ||
          getMessage('labelText.frameMaterial')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );
  return newErrors;
}

const validateManufacturingMethod = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  // Manufacturing Method
  newErrors = ValidateSelector(
    getValue(questions.manufacturingMethod),
    buildElementId(id, 'BOAT_MANUFACTURINGMETHOD'),
    newErrors,
    validateAll,
    questionID,
    getMessage
      ? `${caption} : ${
          questions.manufacturingMethod?.question ||
          getMessage('labelText.manufacturingMethod')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );
  return newErrors;
}

const validateManufactureYear = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  // Manufacture year
  newErrors = ValidateNumeric(
    getValue(questions.manufactureYear),
    buildElementId(id, 'BOAT_MANUFACTUREYEAR'),
    newErrors,
    validateAll,
    1800,
    new Date().getFullYear() + 1,
    questionID,
    '^([1-9][0-9]{0,3})$',
    getMessage
      ? `${caption} : ${
          questions.manufactureYear?.question ||
          getMessage('labelText.manufactureYear')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );
  return newErrors;
}

const validateInspectionClass = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  // Inspectionclass
  newErrors = ValidateSelector(
    getValue(questions.inspectionclass),
    buildElementId(id, 'BOAT_INSPECTIONCLASS'),
    newErrors,
    validateAll,
    questionID,
    getMessage
      ? `${caption} : ${
          questions.inspectionclass?.question ||
          getMessage('labelText.inspectionClass')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );
  return newErrors;
}

const validatePrimaryEngineBrand = ({ newErrors, id, questions, validateAll, questionID, caption, getMessage, key }) => {
  // Boat engine brand
  newErrors = ValidateSelector(
    getValue(questions[`engineBrand-${key}`]),
    buildElementId(id, `${key}_BOAT_ENGINEBRAND`),
    newErrors,
    validateAll,
    questionID,
    getMessage
    ? `${caption} : ${
        questions[`engineBrand-${key}`]?.question ||
        getMessage('labelText.engineBrand')
      } - ${getMessage('error.fill.in.missing.information')}`
    : ''
  );
  return newErrors;
}

const validatePrimaryEngineProductionNumber = ({ newErrors, id, questions, validateAll, questionID, caption, getMessage, key }) => {
  let engineProductionNumberMessage =
    questions[`engineProductionNumber-${key}`]?.errorLabel ||
      (getMessage
        ? `${caption} : ${
          questions[`engineProductionNumber-${key}`]?.question ??
            getMessage('labelText.engineProductionNumber')
          } - ${getMessage('error.fill.in.missing.information')}`
        : '');
      engineProductionNumberMessage = engineProductionNumberMessage.replace(
      '- undefined',
      (getMessage ?? questions.boatType.getMessage)(
        'error.fill.in.missing.information'
      )
    );
    // Engine production number
    newErrors = ValidateRegExp({
      value: getValue(questions[`engineProductionNumber-${key}`]),
      id: buildElementId(id, `${key}_BOAT_ENGINEPRODUCTIONNUMBER`),
      newErrors,
      validateAll,
      length: 1,
      questionID,
      regExp: '(^[0-9a-zA-Z\\u00C0-]+([ |-][0-9a-zA-Z\\u00C0-]+)*$)|(^$)',
      errorLabel: engineProductionNumberMessage,
    });
  return newErrors;
}

const validatePrimaryEngineYearofManufacture = ({ newErrors, id, questions, validateAll, questionID, caption, getMessage, key }) => {
  // Engine year of manufacture
  newErrors = ValidateNumeric(
    getValue(questions[`engineYearOfManufacture-${key}`]),
    buildElementId(id, `${key}_BOAT_ENGINEYEAROFMANUFACTURE`),
    newErrors,
    validateAll,
    1800,
    new Date().getFullYear() + 1,
    questionID,
    '^([1-9][0-9]{0,3})$',
    getMessage
      ? `${caption} : ${
        questions[`engineYearOfManufacture-${key}`]?.question ||
          getMessage('labelText.engineYearOfManufacture')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );
  return newErrors;
}

const validatePrimaryEnginePower = ({ newErrors, id, questions, validateAll, questionID, caption, getMessage, key }) => {
  // Engine power
  newErrors = ValidateNumeric(
    getValue(questions[`enginePower-${key}`]),
    buildElementId(id, `${key}_BOAT_ENGINEPOWER`),
    newErrors,
    validateAll,
    1,
    9999,
    questionID,
    '^[1-9]\\d*(?:\\.\\d{1,2})?$',
    getMessage
      ? `${caption} : ${
        questions[`enginePower-${key}`]?.question ||
          getMessage('labelText.enginePower')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );
  return newErrors;
}

const validateRegistrationnNumber = ({ newErrors, id, questions, validateAll, questionID, caption, getMessage, key }) => {
  let registrationNumberMessage =
    questions[`registrationNumber-${key}`]?.errorLabel ||
      (getMessage
        ? `${caption} : ${
          questions[`registrationNumber-${key}`]?.question ??
            getMessage('labelText.registrationNumber')
          } - ${getMessage('error.fill.in.missing.information')}`
        : '');
        registrationNumberMessage = registrationNumberMessage.replace(
      '- undefined',
      (getMessage ?? questions.boatType.getMessage)(
        'error.fill.in.missing.information'
      )
    );
    // Engine production number
    newErrors = ValidateRegExp({
      value: getValue(questions[`registrationNumber-${key}`]),
      id: buildElementId(id, `${key}_BOAT_REGISTRATIONNUMBER`),
      newErrors,
      validateAll,
      length: 1,
      questionID,
      regExp: '(^[0-9a-zA-Z\\u00C0-]+([ |-][0-9a-zA-Z\\u00C0-]+)*$)|(^$)',
      errorLabel: registrationNumberMessage,
    });
  return newErrors;
}


const validatePrimaryEngine = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  // Primary engines
  newErrors = ValidateSegmented(
    getValue(questions.primaryengines),
    buildElementId(id, 'BOAT_PRIMARYENGINES'),
    newErrors,
    validateAll,
    questionID,
    getMessage
    ? `${caption} : ${
        questions.primaryengines?.question ||
        getMessage('labelText.primaryEngines')
      } - ${getMessage('error.fill.in.missing.information')}`
    : ''
  );
  return newErrors;
}

const validateMotorBoatType = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  // Motor boat type
  newErrors = ValidateSelector(
    getValue(questions.motorBoatType),
    buildElementId(id, 'BOAT_MOTORBOATTYPE'),
    newErrors,
    validateAll,
    questionID,
    getMessage
    ? `${caption} : ${
       questions.motorBoatType || getMessage('labelText.insuredItem')
      } - ${getMessage('error.fill.in.missing.information')}`
    : ''
  );
  return newErrors;
}

const validateBoatEngine = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  // Boat Engine
  newErrors = ValidateSegmented(
    getValue(questions.boatEngine),
    buildElementId(id, 'BOAT_BOATENGINE'),
    newErrors,
    validateAll,
    questionID,
    getMessage
    ? `${caption} : ${
        questions.boatEngine?.question ||
        getMessage('labelText.boatEngine')
      } - ${getMessage('error.fill.in.missing.information')}`
    : ''
  );
  return newErrors;
}

const validateDamageCover = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  // Damagecover
  newErrors = ValidateSegmented(
    getValue(questions.damagecover),
    buildElementId(id, 'BOAT_DAMAGECOVER'),
    newErrors,
    validateAll,
    questionID,
    getMessage
    ? `${caption} : ${
        questions.damagecover?.question ||
        getMessage('labelText.damageCover')
      } - ${getMessage('error.fill.in.missing.information')}`
    : ''
  );
  return newErrors;
}

const validateBoatValue = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  // Boat value
  newErrors = ValidateNumeric(
    getValue(questions.value),
    buildElementId(id, 'BOAT_VALUE'),
    newErrors,
    validateAll,
    1,
    9999999,
    questionID,
    '^[1-9]\\d*(?:\\.\\d{1,2})?$',
    getMessage
    ? `${caption} : ${
        questions.value?.question ||
        getMessage('labelText.boatValue')
      } - ${getMessage('error.fill.in.missing.information')}`
    : ''
  );
  return newErrors;
}

const validateBoatMuninicipality = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  // Boat municipality
  newErrors = ValidateSelector(
    getValue(questions.municipality),
    buildElementId(id, 'BOAT_MUNICIPALITY'),
    newErrors,
    validateAll,
    questionID,
    getMessage
    ? `${caption} : ${
        questions.municipality?.question ||
        getMessage('labelText.boatMunicipality')
      } - ${getMessage('error.fill.in.missing.information')}`
    : ''
  );
  return newErrors;
}

const validateBoatUsedInCompetitionsOrRaces = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  // boatUsedInCompetitionsOrRaces
  newErrors = ValidateSegmented(
    getValue(questions.boatUsedInCompetitionsOrRaces),
    buildElementId(id, 'BOAT_USEDINCOMPETITIONSORRACES'),
    newErrors,
    validateAll,
    questionID,
    getMessage
    ? `${caption} : ${
        questions.boatUsedInCompetitionsOrRaces?.question ||
        getMessage('labelText.boatUsedInCompetitionsOrRaces')
      } - ${getMessage('error.fill.in.missing.information')}`
    : ''
  );
  return newErrors;
}

const validateOwnedByFinanceCompany = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  // ownedByFinanceCompany
  newErrors = ValidateSegmented(
    getValue(questions.ownedByFinanceCompany),
    buildElementId(id, 'BOAT_OWNEDBYFINANCECOMPANY'),
    newErrors,
    validateAll,
    questionID,
    getMessage
    ? `${caption} : ${
        questions.ownedByFinanceCompany?.question ||
        getMessage('labelText.ownedByFinanceCompany')
      } - ${getMessage('error.fill.in.missing.information')}`
    : ''
  );
  return newErrors;
}

const validateFinanceCompany = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  // Boat municipality
  newErrors = ValidateSelector(
    getValue(questions.financeCompany),
    buildElementId(id, 'BOAT_FINANCECOMPANY'),
    newErrors,
    validateAll,
    questionID,
    getMessage
    ? `${caption} : ${
        questions.financeCompany?.question ||
        getMessage('labelText.boatFinanceCompany')
      } - ${getMessage('error.fill.in.missing.information')}`
    : ''
  );
  return newErrors;
}

const validateBoatQuestions = (
  id,
  questions,
  validateAll,
  questionID,
  errors,
  caption,
  getMessage
) => {
  let newErrors = { add: [], remove: [] };
  const boatType = questions.boatType || { value: '' };
  const motorBoats = ['Motorboat', 'Motor sailor'];
  // Mandatory, validate always type
  newErrors = ValidateSelector(
    getValue(questions.boatType),
    buildElementId(id, 'BOAT_TYPE'),
    newErrors,
    validateAll,
    questionID,
    getMessage
      ? `${caption} : ${
          boatType.question || getMessage('labelText.insuredItem')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );

  if (validateAll === true && getValue(questions.boatType) === 'choose') {
    newErrors.remove = [
      ...newErrors.remove,
      ...errors
        .filter(
          (record) =>
            record.id.indexOf(id) !== -1 && record.id !== id + '_BOAT_TYPE'
        )
        .map((record) => record.id),
    ];
  } else if (
    getValue(questions.boatType) &&
    getValue(questions.boatType) !== 'choose'
  ) {
	  if (getValue(questions.boatType) === 'Motorboat') {
      newErrors = validateMotorBoatType(newErrors, id, questions, validateAll, questionID, caption, getMessage);
    }
    newErrors = validateMake(newErrors, id, questions, validateAll, questionID, caption, getMessage);
    newErrors = validateModel(newErrors, id, questions, validateAll, questionID, caption, getMessage);
    newErrors = validateFrameMaterial(newErrors, id, questions, validateAll, questionID, caption, getMessage);
    newErrors = validateManufacturingMethod(newErrors, id, questions, validateAll, questionID, caption, getMessage);
    newErrors = validateManufactureYear(newErrors, id, questions, validateAll, questionID, caption, getMessage);
    newErrors = validateInspectionClass(newErrors, id, questions, validateAll, questionID, caption, getMessage);
    if (getValue(questions.boatType) === 'Sailboat') {
      newErrors = validateBoatEngine(newErrors, id, questions, validateAll, questionID, caption, getMessage);
      newErrors = validateBoatUsedInCompetitionsOrRaces(newErrors, id, questions, validateAll, questionID, caption, getMessage)
    }
    if (
      motorBoats.indexOf(getValue(questions.boatType)) > -1 ||
      getValue(questions.boatEngine) === 'Yes'
    ) {      
      newErrors = validatePrimaryEngine(newErrors, id, questions, validateAll, questionID, caption, getMessage);
      Array(+getValue(questions.primaryengines))
				?.fill()
				?.map((item, index) => {
					const key = index+1;
          newErrors = validatePrimaryEngineBrand({ newErrors, id, questions, validateAll, questionID, caption, getMessage, key });
          newErrors = validatePrimaryEngineProductionNumber({newErrors, id, questions, validateAll, questionID, caption, getMessage, key});
          newErrors = validatePrimaryEngineYearofManufacture({newErrors, id, questions, validateAll, questionID, caption, getMessage, key});
          newErrors = validatePrimaryEnginePower({newErrors, id, questions, validateAll, questionID, caption, getMessage, key});
          if(Number(getValue(questions[`enginePower-${key}`])) >= 21) {
            newErrors = validateRegistrationnNumber({ newErrors, id, questions, validateAll, questionID, caption, getMessage, key })
          }
          return item;
        })
    }   
    newErrors = validateDamageCover(newErrors, id, questions, validateAll, questionID, caption, getMessage);
    newErrors = validateBoatValue(newErrors, id, questions, validateAll, questionID, caption, getMessage);
    newErrors = validateBoatMuninicipality(newErrors, id, questions, validateAll, questionID, caption, getMessage);
    newErrors = validateOwnedByFinanceCompany(newErrors, id, questions, validateAll, questionID, caption, getMessage)
    if(getValue(questions.ownedByFinanceCompany) === 'Yes') {
      newErrors = validateFinanceCompany(newErrors, id, questions, validateAll, questionID, caption, getMessage)
    }
  }
  return {
    add: newErrors.add.filter(Boolean),
    remove: newErrors.remove.filter(Boolean),
  };
};

export default validateBoatQuestions;
